import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  FormLabel,
  Button,
  Typography,
} from "@material-ui/core";
import { connect } from "react-redux";
import { apiEndpoints, apiGetRequest } from "src/utils/api/api";
import React, { useEffect, useState } from "react";
import actions from "src/duck/global/actions";
import Skeleton from "@material-ui/lab/Skeleton";
import { NavLink as RouterLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  accordion: {
    marginTop: theme.spacing(1.5),
  },
  fileicon: {
    fontSize: "2.7rem",
    marginTop: theme.spacing(2),
  },
  filename: {
    margin: theme.spacing(1),
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const MyAccountPreview = ({
  enableGlobalLoader,
  disableGlobalLoader,
  titleUpdate,
  setLogoutUser,
  ...rest
}) => {
  const classes = useStyles();
  const [myAccountData, setMyAccountData] = useState(null);

  useEffect(() => {
    enableGlobalLoader();
    apiGetRequest(apiEndpoints.getMyAccountUser.path, true).then((data) => {
      setMyAccountData(data);
      disableGlobalLoader();
    }).catch((error) => {
      disableGlobalLoader();
      if (error.response && error.response.status === 401) {
        setLogoutUser();
      }
    });
    return () => {};
  }, []);

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" pb={1}>
        <Button
          color="primary"
          variant="contained"
          component={RouterLink}
          className={classes.toolbarLeftButton}
          to={`/zmianahasla`}
        >
          Zmiana hasła
        </Button>
      </Box>
      <Card className={clsx(classes.root)} {...rest}>
          <Box component="main">
            <Grid container className={classes.root}>
              <Grid item xs={12} elevation={2}>
                <FormControl fullWidth className={classes.formcontrol}>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Login
                  </FormLabel>
                  {myAccountData?.username ? (
                    <Typography>{myAccountData.username}</Typography>
                  ) : (
                    <Skeleton />
                  )}
                </FormControl>
                <FormControl fullWidth className={classes.formcontrol}>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Imię
                  </FormLabel>
                  {myAccountData?.firstName ? (
                    <Typography>{myAccountData.firstName}</Typography>
                  ) : (
                    <Skeleton />
                  )}
                </FormControl>
                <FormControl fullWidth className={classes.formcontrol}>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Nazwisko
                  </FormLabel>
                  {myAccountData?.lastName ? (
                    <Typography>{myAccountData.lastName}</Typography>
                  ) : (
                    <Skeleton />
                  )}
                </FormControl>
                <FormControl fullWidth className={classes.formcontrol}>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    E-mail
                  </FormLabel>
                  {myAccountData?.email ? (
                    <Typography>{myAccountData.email}</Typography>
                  ) : (
                    <Skeleton />
                  )}
                </FormControl>
                <FormControl fullWidth className={classes.formcontrol}>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Profile
                  </FormLabel>
                  {myAccountData ? (
                    myAccountData.userProfiles?.length > 0 ? (
                      <Box pl={2}>
                        <Typography>
                          <ul>
                            {myAccountData.userProfiles.map((profile) => {
                              return <li>{profile.name}</li>;
                            })}
                          </ul>
                        </Typography>
                      </Box>
                    ) : (
                      <Typography>-</Typography>
                    )
                  ) : (
                    <Skeleton />
                  )}
                </FormControl>
                <FormControl fullWidth className={classes.formcontrol}>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Instytucja
                  </FormLabel>
                  {myAccountData?.institutionName ? (
                    <Typography>{myAccountData.institutionName}</Typography>
                  ) : (
                    <Skeleton />
                  )}
                </FormControl>
                <FormControl fullWidth className={classes.formcontrol}>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Status
                  </FormLabel>
                  {myAccountData ? (
                    <Typography>
                      {myAccountData.active ? "Aktywny" : "Zablokowany"}
                    </Typography>
                  ) : (
                    <Skeleton />
                  )}
                </FormControl>
                <FormControl fullWidth className={classes.formcontrol}>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Data aktywności
                  </FormLabel>
                  {myAccountData ? (
                    <Typography>
                      {myAccountData.activeUntil
                        ? myAccountData.activeUntil
                        : myAccountData.activeNoTimeLimit
                        ? "Czas nieokreślony"
                        : "-"}
                    </Typography>
                  ) : (
                    <Skeleton />
                  )}
                </FormControl>
                <Box className={classes.paddingtop}>
                  <Button
                    color="primary"
                    className={classes.button}
                    component={RouterLink}
                    to={`/`}
                  >
                    Zamknij
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
      </Card>
    </Box>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  setLogoutUser: () => dispatch(actions.setLogoutUser())
});

export default connect(null, mapDispatchToProps)(MyAccountPreview);
